<template>
  <v-tooltip
    class="mr-4"
    top
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="#6A6E7B"
        outline
        v-bind="attrs"
        @click="onClick($event)"
        v-on="on"
      >
        <slot />
      </v-btn>
    </template>
    <span>
      <slot name="tooltip" />
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'BtnTooltip',
  props: {
    onClick: {
      type: Function,
      default() {
        return () => {};
      },
    },
  },
};
</script>
